<template>
    <div class="container-fluid footer">
        <div class="footer-block row">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-lg-1"></div>
                    <div class="col-sm-12 col-lg-2">

                        <a :href="brandWebsite" target="_blank">
                            <v-lazy-image :src="'/img/brand/' + brand"
                                          alt="logo"
                                          class="logo"
                                          :placeholder="'/img/brand/' + brand" />
                        </a>
                    </div>
                    <div v-for="(item, i) in data" :key="i" class="col-sm-12 col-md-4 col-lg-2">
                        <span class="h5">{{item.title}}</span>
                        <div class="column-content">
                            <ul class="">
                                <li v-for="(link, index) in item.menubar" :key="index">
                                    <a v-if="(link.isActive == true && (!isNational || link.showForNational === true))" :href="link.link" :target="link.target">{{ link.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="!isNational" class="col-sm-12 col-md-4 col-lg-2 addr-box">
                        <span class="h5">{{dealerLocation?.name}}</span>
                        <div class="column-content">
                            <p>{{dealerLocation?.address?.addressLine1}}</p>
                            <p v-if="this.dealerLocation.address?.addressLine2">{{this.dealerLocation?.address?.addressLine2}}</p>
                            <p v-if="dealerLocation?.address?.city || dealerLocation?.address?.state || dealerLocation?.address?.postalCode">{{dealerLocation.address.city}}, {{dealerLocation.address.state}} {{dealerLocation.address.postalCode}}</p>
                            <p v-if="dealerLocation?.address?.country">{{dealerLocation.address.country}}</p>
                            <p v-if="dealerLocation?.salesPhoneNo === dealerLocation?.servicePhoneNo">
                                <strong>{{phoneNo}}:</strong> {{dealerLocation?.salesPhoneNo}}
                            </p>
                            <template v-if="dealerLocation?.salesPhoneNo !== dealerLocation?.servicePhoneNo">
                                <p><strong>{{salesNo}}:</strong> {{dealerLocation?.salesPhoneNo}}</p>
                                <p><strong>{{serviceNo}}:</strong> {{dealerLocation?.servicePhoneNo}}</p>
                            </template>
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-sm-12 col-lg-1"></div>
                    <div class="col-sm-12 col-md-5"><p>&copy; {{copyright}}</p></div>
                    <div class="col-sm-12 col-md-5">
                        <div class="social-icons" role="list">
                            <span v-for="(media, i) in social" :key="i">
                                <a v-if="(media.isActive == true && (!isNational || media.showForNational === true))" :href="media.url" class="icon-item" target="_blank">
                                    <i v-bind:class="['social fab ' +media.icon]" :title="media.label"></i>
                                    <span class="sr-only">{{media.label}}</span>
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-1"></div>
                </div>
                <div class="row"></div>

            </div>
        </div>
    </div>


</template>
<script>
    import VLazyImage from "v-lazy-image";
    import getBrandDetails from "../../constants/brand.config";
    import { businessHours, phoneNo, salesNo, serviceNo } from '../../constants/labels.config';
    import "bootstrap/dist/css/bootstrap.min.css";

    export default {
        name: "SiteFooter",
        props:['brand', 'data', 'social', 'copyright', 'termCondition'],
        data(){
            return {      
                dealerLocation:window.DEALER_LOCATION,   
                businessHours,
                phoneNo, 
                salesNo, 
                serviceNo,
                brandWebsite: getBrandDetails(sessionStorage.getItem("brand"), "brandUrl"),
                isNational: false
            }
        },
        methods:{
            showCookieSettings: function(){
                 let showSettingsEvent = new Event('show_cookie_settings');
                document.dispatchEvent(showSettingsEvent);
            }
        },
        mounted() {
            this.isNational = window.IS_NATIONAL;
        },
        components: {
            VLazyImage,
        }
    };
</script>
